var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container", attrs: { id: "preview" } }, [
    _c(
      "div",
      {
        staticStyle: {
          margin: "10px",
          display: "inline-block",
          padding: "10px",
        },
      },
      [
        _c(
          "div",
          { staticStyle: { "margin-right": "2rem", display: "inline" } },
          [
            _c("div", [
              _c("span", [
                _vm._v(" " + _vm._s(_vm.signature.firstname) + " "),
                _c("b", { staticStyle: { color: "rgb(106, 191, 158)" } }, [
                  _vm._v(_vm._s(_vm.signature.lastname)),
                ]),
              ]),
              _c("br"),
              _c("span", [_vm._v(_vm._s(_vm.signature.job))]),
            ]),
            _c("br"),
            _c("div", [
              _c("span", [_vm._v(" " + _vm._s(_vm.signature.phone) + " ")]),
              _c("br"),
              _c("span", [
                _vm._v(" " + _vm._s(_vm.signature.address) + " "),
                _vm.signature.city || _vm.signature.postalCode
                  ? _c("span", [
                      _vm._v(
                        " - " +
                          _vm._s(_vm.signature.postalCode) +
                          ", " +
                          _vm._s(_vm.signature.city)
                      ),
                    ])
                  : _vm._e(),
                _c("br"),
                _vm._v(" " + _vm._s(_vm.signature.country) + " "),
                _c("br"),
                _c(
                  "a",
                  {
                    staticStyle: {
                      "text-decoration": "underline",
                      color: "black",
                    },
                    attrs: { href: "https://www.fr-gps.com" },
                  },
                  [_vm._v("www.fr-gps.com")]
                ),
              ]),
            ]),
          ]
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }